<template>
  <Container type="card-full">
    <div class="main">
      <div class="view-container">
        <div class="view-box">
          <!-- 报价一览表 -->
          <div id="bjview-box" style="width:100%;">
            <div class="bjview-box" style="margin:0 auto;">
              <div class="bjview-header">
                <div class="bjview-index">
                  序号
                </div>
                <div class="bjview-name">
                  报价人名称
                </div>
                <div class="bjview-name-t">
                  评审文件
                </div>
                <div class="bjview-list header-jl">
                  比选报价({{ projectQuotationmodeflg.three }})
                </div>
                <!-- <div  class="bjview-name-t" style="width:200px;">
                    报价时间
                </div> -->
                <div class="bjview-name-t">
                  报价人
                </div>
              </div>
              <div v-for="(i, index) in dialogList" :key="i.pbrcomid" class="bjview-item">
                <div class="bjview-index">
                  <div>
                    {{ index + 1 }}
                  </div>
                </div>
                <div class="bjview-name">
                  <div>
                    {{ i.origin[0].pbrcomname }}
                  </div>
                </div>
                <div class="bjview-name-t">
                  <div>
                    <div
                      v-if="i.origin[0].appendurl && (+$store.getters.loginUser.comtype != 3 || (+i.pbrcomid === +$store.getters.loginUser.comid && +$store.getters.loginUser.comtype == 3))"
                      class="view-filelist">
                      <div class="view-fileitem">
                        <div class="view-filename" @click="downFile(i.origin[0].appendurl, i.origin[0].appendid)">
                          <a :src="uploadAddr + i.origin[0].appendurl">{{ i.origin[0].appendfilename |
                              toolongOmitted
                          }}</a>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="i.origin[0].appendurl && +$store.getters.loginUser.comtype === 3 && +i.pbrcomid !== +$store.getters.loginUser.comid"
                      class="view-value">不可查看</div>
                    <div v-else class="view-value">无</div>

                  </div>
                </div>
                <div class="bjview-list">
                  <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                    <!-- <div class="item-index">第{{j.pbtseq}}轮</div> -->
                    <div class="item-price" v-if="+project.projectquotationmode === 1">￥{{ j.pbramt | qfwVal }}元(
                      <amount :money="String(j.pbramt)" v-if="j.pbramt" />)
                    </div>
                    <div class="item-price" v-else>{{ j.pbrpricerate }}%</div>
                  </div>
                </div>
                <!-- <div class="bjview-list-r">
                    <div v-for="j in i.origin" :key="j.pbrid" class="bjview-list-item">
                      <div class="item-index">{{j.pbrtime | newDate}}</div>
                    </div>
                </div> -->
                <!-- <div class="bjview-name-t">
                  {{i.origin[0].psuoffertime}}
                </div> -->
                <div class="bjview-name-t bjview-red">
                  <!-- <div
                    v-if="+i.origin[0].psuamtcommituserid && +i.origin[0].psuamtcommituserid !== +i.origin[0].psuuserid">
                    系统自动确认</div>
                  <div v-else> -->
                  <div style="text-align:center;">{{ i.origin[0].psuname }}</div>
                  <!-- <div>{{i.origin[0].psuamtcommittime | longDate}}</div> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import amount from '../../views/common/amount'
export default {
  name: "exPsuIndex",
  mixins: [common],
  data() {
    return {
      project: {},
      appendList: [],
      BJList: [],
      dialogList: []
    }
  },
  created() {
  },
  mounted() {
  },
  async activated() {
    await this.init()
    this.getModel()
    this.getAppend()
    this.getBJList()
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    },
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '上浮率报价',
          two: '最高上浮率报价',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '下浮率报价',
          two: '最高下浮率报价',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '折扣率报价',
          two: '最低折扣率报价',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额报价',
        three: '金额'
      }
    }
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4)
        }
        else {
          return val
        }
      }
    }
  },
  components: { amount },
  methods: {
    init() {
      this.project = {}
      this.appendList = []
      this.BJList = []
    },
    async getModel() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: this.$store.getters.expertLoginUser.projectid }
      })
      this.project = res
    },
    async getAppend() {
      let res = await request({
        url: '/xmgl/pbr/checkJjPlan',
        method: "get",
        params: { projectid: this.$store.getters.expertLoginUser.projectid }
      })
      if (+this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.comid === +this.$store.getters.loginUser.comid
        })
      }
      this.appendList = res
    },
    async getBJList() {
      let model = {}
      model.pbrprojectid = this.$store.getters.expertLoginUser.projectid
      let res = await request({
        url: '/xmgl/pbr/getbjList',
        method: "get",
        params: model
      })
      if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.pbrcomid === +this.$store.getters.loginUser.comid
        })
      }
      res.map(e => {
        e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
      })
      this.dialogList = this.Sortbycomid(res)
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      return afterData
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  font-size: 14px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.view-filename {
  color: #409EFF;
  cursor: pointer;
  flex: 1;
}

.p-append-h {
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
  display: flex;
  justify-content: space-around;
  text-align: center;
  border: 1px solid #e8eaec;
}

.p-append-h-item {
  flex: 1;
}

.p-append-h-item:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b {
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.p-append-b-item {
  display: flex;
  text-align: center;
  border-bottom: 1px solid #e8eaec;
  height: 31px;
  line-height: 31px;
}

.p-append-b-item div:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b-item div {
  flex: 1;
}

.el-n {
  white-space: nowrap;
  /*设置不换行*/
  overflow: hidden;
  /*设置隐藏*/
  text-overflow: ellipsis;
}

.name {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-box {
  border-top: 1px solid #e8eaec;
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.bjview-header {
  display: flex;
  // justify-content: center;
  text-align: center;
  height: 48px;
  line-height: 48px;
  background-color: #f8f8f9;
}

.bjview-index {
  text-align: center;
  width: 50px;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-item {
  display: flex;
  line-height: 35px;
}

.bjview-name {
  overflow: hidden;
  width: 210px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-list-r {
  width: 200px;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  // border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-name-t {
  overflow: hidden;
  width: 260px;
  // flex: 1;
  // -webkit-box-flex: 1;
  border-bottom: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bjview-name:last-child {
  border-right: none;
}

.header-jl {
  border-bottom: 1px solid #e8eaec;
}

.bjview-list {
  flex: 4;
  -webkit-box-flex: 4;
  justify-content: space-around;
  box-sizing: border-box;
  // padding: 100px 0 0;
  border-right: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
  overflow: hidden;
}

.bjview-list-item {
  display: flex;
  padding-left: 10px;
  border-bottom: 1px solid #e8eaec;
  // height:100%;
}

.bjview-list-item:last-child {

  height: 100%;
}

.item-index {
  // width: 150px;
  flex: 2;
  -webkit-box-flex: 1;
  border-right: 1px solid #e8eaec;
  text-align: center;
}

.item-price {
  padding-left: 10px;
  // width: 350px;
  flex: 8;
  -webkit-box-flex: 8;
}

.bjview-button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-i {
  margin: 30px 0 auto;
  width: 200px;
}

.bjview-red {
  color: red;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform:translate(-50%,-50%);
}
</style>
